import {
    HotkeyBinding,
    View,
} from 'radpresentation.htmlclient.defaultviewextensions';
import type CreatePropertyGroupViewViewModel from '@/ViewModels/Views/CreatePropertyGroupViewViewModel';
import layout from './CreatePropertyGroupView.html?raw';

class CreatePropertyGroupView extends View {
    private view: JQuery<HTMLElement>;

    constructor(
        private viewModel: CreatePropertyGroupViewViewModel,
        private element: any
    ) {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, layout);

        HotkeyBinding.addHotkey(
            this.view[0],
            'esc',
            this.viewModel.cancel.onClick.bind(this)
        );
        HotkeyBinding.addHotkey(
            this.view[0],
            'enter',
            this.viewModel.okay.onClick.bind(this)
        );

        return this.view;
    }
}

export default CreatePropertyGroupView;
